import React, { useState, useEffect } from "react";
import {Link, useNavigate, useParams} from "react-router-dom";
import { Actions as REPORTACTIONS } from "../../store/actions/reportActions";

import { connect } from "react-redux";
import {
    ChevronDownIcon,
    DocumentArrowDownIcon,
    DocumentTextIcon,
    PencilSquareIcon,
    StarIcon
} from "@heroicons/react/20/solid";


const CustomReportList = ({
    customReports,
    duplicateReport,
}) => {

    const navigate = useNavigate();

    return (
        <>
            <div className="col-xs-12 mt-8">
                <div className="pull-left">
                    <h4>Custom Reports</h4>
                </div>
                <Link
                    to="/advisor/reports/customReports/new"
                    className="btn btn-primary pull-right"
                >
                    <DocumentTextIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
                    <span style={{ float: "left" }}>New Custom Report</span>
                </Link>
            </div>
            <div className="clearfix" />

            <table className="js-table-sections table table-hover">
                {/*<Pagination />*/}
                <thead style={{ display: "table-header-group" }}>
                    <tr>
                        <th>
                            Name
                        </th>
                        <th className="text-right">
                            Actions
                        </th>
                    </tr>
                </thead>
                <tbody>
                {customReports?.length ? (
                    <>
                        {customReports?.map((report) => {
                            return (
                                <tr
                                    key={report?.id}>
                                    <td>{report?.name}</td>
                                    <td className="text-right">
                                        <Link
                                            className="btn btn-success"
                                            to={`/advisor/reports/customReports/${report?.id}`}
                                        >
                                            <DocumentTextIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
                                            <span style={{ float: "left" }}>Edit</span>
                                        </Link>
                                        <a
                                            className="btn btn-danger ml-3"
                                            onClick={() => duplicateReport({data: report, navigate})}
                                        >
                                            <DocumentTextIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
                                            <span style={{ float: "left" }}>Copy</span>
                                        </a>
                                    </td>
                                </tr>
                            );
                        })}
                    </>
                ) : null}

                </tbody>
            </table>
        </>
    )
}

const mapStateToProps = (state) => {
	return {
		reportPacks: state.advisors?.reports?.reportPacks,
		customReports: state.advisors?.reports?.customReports,
	};
};

const mapDispatchToProps = (dispatch) => ({
	getReportPacks: () => dispatch(REPORTACTIONS.getReportPacks()),
	getCustomReports: () => dispatch(REPORTACTIONS.getCustomReports()),
	duplicateReport: (report) => dispatch(REPORTACTIONS.duplicateReport(report)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CustomReportList);
